import { Flex, Icon, Center, Button, Box, Avatar } from '@chakra-ui/react';
import { NotificationCard } from '../../components/Card';
import { NotificationTime } from '../../components/Time';
import { decode } from 'js-base64';
import { LayersThree02 } from '@kula-ai/icons/dual-tone/LayersThree02';
import { CollapsibleSection } from '../referral-notifications/components';
import { KText } from '@/ui-library/components';
import { useHistory } from 'react-router-dom';
import { CREDIT_MANAGEMENT_PATH } from '@/components/ats/actions/background-check/backgroundCheckApi';

const FraudDetectionCredit = ({ notification = {} }) => {
  const history = useHistory();
  const { custom_attributes } = notification;

  let requestedBy = null;
  try {
    const data = JSON.parse(decode(custom_attributes));
    requestedBy = data?.requested_by;
  } catch {
    // ignore decode errors
  }

  return (
    <Flex alignItems="baseline" gap="6px">
      <Center
        minW="34px"
        h="34px"
        borderRadius="sm"
        bg="primary-100"
        flexShrink={0}
      >
        <Icon as={LayersThree02} color="primary-500" width="16px" />
      </Center>
      <Flex flexDir="column" ml="16px" gap="8px" alignSelf="start" flex="1">
        <KText fontWeight="semiBold">
          [Action required] Credit request for fraud detector in Kula
        </KText>

        <CollapsibleSection title="Details">
          <Box p="12px 16px">
            <KText color="secondary-700" mb="8px">
              Your team has run out of credits and can&apos;t screen candidates
              for fraud until credits are added
            </KText>
            {requestedBy?.name && (
              <Flex alignItems="center" gap="6px">
                <KText fontWeight="semiBold" color="secondary-900">
                  Requested by:
                </KText>
                <Avatar
                  size="2xs"
                  borderRadius="4px"
                  src={requestedBy.avatar_url}
                  name={requestedBy.name}
                />
                <KText color="secondary-700">{requestedBy.name}</KText>
              </Flex>
            )}
          </Box>
        </CollapsibleSection>

        <NotificationTime notification={notification} />

        <Button
          variant="primary"
          size="sm"
          w="fit-content"
          onClick={() => history.push(CREDIT_MANAGEMENT_PATH)}
        >
          Top up credits
        </Button>
      </Flex>
    </Flex>
  );
};

export const FraudDetectionCreditNotification = ({
  notification = {},
  onClose = () => {},
}) => {
  return (
    <NotificationCard notification={notification}>
      <FraudDetectionCredit notification={notification} onClose={onClose} />
    </NotificationCard>
  );
};
